export type ConditionalWrapperChildren = React.PropsWithChildren<any> | null;

export const ConditionalWrapper = ({
	condition,
	wrapper,
	children,
}: {
	condition: boolean;
	wrapper: (children: ConditionalWrapperChildren) => ConditionalWrapperChildren;
	children: ConditionalWrapperChildren;
}): any => (condition ? wrapper(children) : children);
